/*! Bootstrap 5 styling wrapper for FixedHeader
 * © SpryMedia Ltd - datatables.net/license
 */

import jQuery from 'jquery';
import DataTable from 'datatables.net-bs5';
import FixedHeader from 'datatables.net-fixedheader';

// Allow reassignment of the $ variable
let $ = jQuery;



export default DataTable;
